module.exports = __webpack_public_path__ + "img/corporate-1.4009c57e.jpg";